module.exports = __webpack_public_path__ + "img/collection-diamondJewelryWhitegold.10a8d0a.jpg";